import { AnyAction } from 'redux';
import { PaginatedResponse } from '@synergy/api';

import { STATIC_SITES_DELETED } from '../../store/static-sites-actions';
import {
    STATIC_SITES_LIST_ERROR,
    STATIC_SITES_LIST_FETCH,
    STATIC_SITES_LIST_RECEIVE,
} from './static-sites-list-actions';
import { StaticSitesDto } from '../../models/static-sites-dto';

export interface StaticSitesListReducerState {
    items: PaginatedResponse<StaticSitesDto>;
    requesting: boolean;
}

const initialStaticSitesListReducerState: StaticSitesListReducerState = {
    items: { limit: 10, page: 0, total: 0, items: [] },
    requesting: false,
};

export const staticSitesListReducer = (
    state: StaticSitesListReducerState = initialStaticSitesListReducerState,
    action: AnyAction
): StaticSitesListReducerState => {
    switch (action.type) {
        case STATIC_SITES_LIST_FETCH: {
            return {
                ...state,
                requesting: true,
            };
        }

        case STATIC_SITES_LIST_RECEIVE: {
            return {
                ...state,
                requesting: false,
                items: action['staticSites'],
            };
        }

        case STATIC_SITES_LIST_ERROR: {
            return {
                ...state,
                requesting: false,
            };
        }

        case STATIC_SITES_DELETED: {
            return {
                ...state,
                items: {
                    ...state.items,
                    items: state.items.items.filter(item => item.id !== action['id']),
                    total: state.items.total - 1,
                },
            };
        }

        default: {
            return state;
        }
    }
};
